import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Handle stale chunk errors after redeployment
// When chunks fail to load (404), auto-reload once to get fresh assets
window.addEventListener("error", (e) => {
  if (
    e.message?.includes("Loading chunk") ||
    e.message?.includes("Failed to fetch dynamically imported module") ||
    e.message?.includes("Unexpected token '<'")
  ) {
    const reloaded = sessionStorage.getItem("chunk_reload");
    if (!reloaded) {
      sessionStorage.setItem("chunk_reload", "1");
      window.location.reload();
    }
  }
});

window.addEventListener("unhandledrejection", (e) => {
  if (
    e.reason?.name === "ChunkLoadError" ||
    e.reason?.message?.includes("Loading chunk")
  ) {
    const reloaded = sessionStorage.getItem("chunk_reload");
    if (!reloaded) {
      sessionStorage.setItem("chunk_reload", "1");
      window.location.reload();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
